module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cta cta-large">\n    <div class="cta__image">\n        <img class="responsiveImage responsiveImage-scale" src="'+
((__t=(img ))==null?'':_.escape(__t))+
'" alt="" />\n    </div>\n    <div class="cta__content">\n        <h3>Can\'t find the right group?</h3>\n        <span>\n            Organize activities for members who share your interests by creating your own group.\n            ';
 if (isLoggedIn) { 
__p+='\n                <a href="'+
((__t=(link.learnMore ))==null?'':_.escape(__t))+
'">Learn more</a>\n            ';
 } 
__p+='\n        </span>\n    </div>\n    <div class="cta__action">\n        ';
 if (isLoggedIn) { 
__p+='\n            <a href="'+
((__t=(link.createGroup ))==null?'':_.escape(__t))+
'" class="btn">Create group</a>\n        ';
 } else { 
__p+='\n            <a href="'+
((__t=(link.learnMore ))==null?'':_.escape(__t))+
'" class="btn">Learn more</a>\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};
